import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
const useDisableScroll = isDisabled => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== isDisabled) {
    t0 = () => {
      if (isDisabled) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
      return _temp;
    };
    t1 = [isDisabled];
    $[0] = isDisabled;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useDisableScroll;
function _temp() {
  document.body.classList.remove("overflow-hidden");
}